import { jsx, jsxs } from "react/jsx-runtime";
import { ListItem, Link, Text } from "@nxt-costco-com/forge-components";
import { SpaceXs, ColorGray700 } from "@nxt-costco-com/forge-design-tokens";
import { ChevronRight } from "@nxt-costco-com/forge-icons/icons/ChevronRight";
import { Analytics } from "../../Analytics/index.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { LegendTilesContainer, LegendItem, SwatchWrapper, LegendColor } from "./styles.js";
const LegendTiles = ({ data }) => {
  const { image_with_legend } = data;
  if (!image_with_legend || image_with_legend.legend_tile.length <= 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(LegendTilesContainer, { variant: "SimpleList", children: image_with_legend.legend_tile.map((tile, index) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ((_a = tile == null ? void 0 : tile.button_config) == null ? void 0 : _a.url) {
      return /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsx(LegendItem, { children: /* @__PURE__ */ jsx(
        Analytics,
        {
          analyticData: {
            adItem: {
              isExternal: (_b = tile == null ? void 0 : tile.button_config) == null ? void 0 : _b.external_site,
              url: (_c = tile == null ? void 0 : tile.button_config) == null ? void 0 : _c.url
            },
            title: tile == null ? void 0 : tile.button_config.entry_title
          },
          children: /* @__PURE__ */ jsxs(Link, { href: (_d = tile == null ? void 0 : tile.button_config) == null ? void 0 : _d.url, children: [
            /* @__PURE__ */ jsxs(
              CostcoBox,
              {
                sx: {
                  alignItems: "center",
                  display: "flex",
                  flexGrow: 1,
                  gap: SpaceXs
                },
                children: [
                  /* @__PURE__ */ jsx(SwatchWrapper, { children: /* @__PURE__ */ jsx(
                    LegendColor,
                    {
                      backgroundColor: (_e = tile == null ? void 0 : tile.swatch_color) == null ? void 0 : _e.hex
                    }
                  ) }),
                  /* @__PURE__ */ jsx(Text, { component: "span", variant: "t6", children: (_f = tile == null ? void 0 : tile.button_config) == null ? void 0 : _f.title })
                ]
              }
            ),
            /* @__PURE__ */ jsx(
              ChevronRight,
              {
                sx: {
                  color: ColorGray700,
                  display: {
                    lg: "none",
                    md: "inline-block"
                  },
                  height: "24px",
                  width: "24px"
                }
              }
            )
          ] })
        }
      ) }) }, index);
    } else
      return /* @__PURE__ */ jsx(ListItem, { children: /* @__PURE__ */ jsxs(LegendItem, { children: [
        /* @__PURE__ */ jsx(SwatchWrapper, { children: /* @__PURE__ */ jsx(
          LegendColor,
          {
            backgroundColor: (_g = tile == null ? void 0 : tile.swatch_color) == null ? void 0 : _g.hex
          }
        ) }),
        /* @__PURE__ */ jsx(Text, { variant: "t6", children: (_h = tile == null ? void 0 : tile.button_config) == null ? void 0 : _h.title })
      ] }) }, index);
  }) });
};
export {
  LegendTiles
};
